import * as React from "react";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IState, IResultEntity, IDataEntity, IDataEntityResponse, IFundFilterResponse, IShareClassFilterResponse, IFilterRequest, ISearch, IAppParams, IPageProperties } from "../models";
import { PageOverview } from "../components/PageOverview";
import { toggleLoading } from "../actions/loading";
import { getShareClassAndFund, getFunds, getFilters, changeFilter, toggleFund, toggleShareClass, toggleAllFunds, toggleShareClassPerformance, getDisclaimers, editWatchlist } from "../actions";


@connect(mapStateToProps, mapDispatchToProps)
export class PageOverviewContainer extends React.Component<React.Props<{}> & IPageProperties, {}>{
	componentWillMount() {
		this.props.getDisclaimers(this.props.appParams);
		this.props.getShareClassAndFund({}, this.props.appParams);
	}
	render() {
		return (
			<PageOverview { ...this.props }></PageOverview>
		);
	}
}

function mapStateToProps(state: IState, ownProps: any): IPageProperties {
	return {
		isLoading: state.loading.isLoading,
		fund: state.fund,
		shareClass: state.shareClass,
		disclaimers: state.disclaimers,
		watchlist: state.watchlist
	};
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IPageProperties {
	return {
		getShareClassAndFund: bindActionCreators(getShareClassAndFund, dispatch),
		getDisclaimers: bindActionCreators(getDisclaimers, dispatch),
		editWatchlist: bindActionCreators(editWatchlist, dispatch),
	};
}




// WEBPACK FOOTER //
// ./src/client/containers/PageOverviewContainer.tsx